<style lang="scss">
    .browse-page {
        padding-bottom: 100px;
        min-height: 600px;
        .page-title {
            color: #ff5b94;
            font-size: 30px;
            font-weight: 600;
            text-transform: uppercase;
            margin: 10px 0 30px;
        }
        .page-title-wrapper {
            position: relative;
            .display-icons {
                position: absolute;
                top: 0;
                right: 0;
                z-index: 100;
            }
            .display-icon {
                font-size: 16px;
                color: #c8c8c8;
                padding: 5px;
                cursor: pointer;
                &.active {
                    color: #595e63;
                }
            }
        }
        .filter-bar {
            margin-bottom: 20px;
        }
        .beat-container {
            margin-bottom: 20px;
        }
    }
    .infinity-loading {
        width: 100px;
        height: 100px;
    }
</style>

<template>
    <div class="browse-page padding" @click="closeFilterBar()">
        <div class="page-title-wrapper">
            <!-- <h1 v-if="page" class="page-title" :style="$highlightColor">{{page.name}}</h1> -->
            <div class="display-icons">
                <span class="block-display-icon display-icon" :style="$iconColorStyle(this.display == 'block')" @click="changeDisplay('block')"><font-awesome-icon icon="th"></font-awesome-icon></span>
                <span class="list-display-icon display-icon" :style="$iconColorStyle(this.display == 'list')" @click="changeDisplay('list')"><font-awesome-icon icon="list"></font-awesome-icon></span>
            </div>
        </div>
        <filter-bar></filter-bar>

        <div v-if="beats.length == 0 && !loading" class="text-center">
            There are no beats which match your search requirements.
        </div>
        <div v-else>
            <div v-if="display == 'block'">
                <div class="row">
                    <beat-container class="col-md-3 col-sm-4 col-xs-6" v-for="beat in beats" :beat="beat" :show-price="true" :show-download="true" :key="beat.id" :image-size="300"></beat-container>
                </div>
            </div>
            <div v-else>
                <beat-row-header></beat-row-header>
                <row-beat-container :parent="page" v-for="beat in beats" :beat="beat" :key="beat.id" :show-price="true" :show-download="true" display="list" :image-size="100"></row-beat-container>
            </div>
        </div>

        <infinite-loading @infinite="loadMore" ref="infiniteLoading" :distance="500">
            <span slot="spinner">
                <img src="https://i.imgur.com/YB4fJJk.gif" class="infinity-loading">
            </span>
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>

    </div>
</template>

<script>
    import SearchBar from './../searchbar.vue'
    import FilterBar from './../beats/filterbar.vue'
    import RowBeatContainer from '../rowbeatcontainer.vue'
    import BeatContainer from './../beatcontainer.vue'
    import BeatRowHeader from './../beatrowheader.vue'
    import LoadingIcon from './../loadingicon.vue'
    import Beat from './../../models/beat'
    import Playlist from './../../classes/playlist'
    import InfiniteLoading from 'vue-infinite-loading'
    import BeatRepository from '../../mixins/beat-repository'
    import Configure from './../../mixins/configure'

    export default {
        props: ['pageId'],
        components: {
            SearchBar, FilterBar, RowBeatContainer, BeatContainer, BeatRowHeader, InfiniteLoading, LoadingIcon
        },
        data() {
            return {
                sharedBeat: null,
                beatsPage: 0,
                beats: [],
                playlist: null,
                loading: false,
                allowUpdate: true,
                infiniteLoadingState: null,
                display: 'list'
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            config() {
                return this.$store.state.currentConfig
            },
            page() {
                if (this.pageId) {
                    let page = this.config.getPageById(this.pageId)
                    this.$store.commit("currentPage", {page: page})

                    return page
                }
            },
            filters() {
                return this.$store.state.filters
            },
            defaultFilters() {
                return this.$store.state.defaultFilters
            },
            filtersSet() {
                for (var i in this.filters) {
                    if (this.filters[i] != this.defaultFilters[i]) {
                        return true
                    }
                }
                return false
            },
            searchQuery() {
                return this.$store.state.search
            },
            returnPlaylistOnly() {
                // If playlist + filters + search not set or playlist + search set + default beats page is showing a playlist or playlist + filters set then need to search/filter the playlist only
                if (this.page != undefined &&
                    (this.page.playlist_id && !this.filtersSet && this.searchQuery == "" ||
                    this.page.playlist_id && this.searchQuery != "" && this.config.defaultBeatsPage.playlist_id ||
                    this.page.playlist_id && this.filtersSet)) {
                    return true
                }
                return false
            },
            playlistManager() {
                return this.$store.state.playlistManager
            }
        },
        mixins: [BeatRepository, Configure],
        methods: {
            getBeats(page) {
                this.loading = true
                if (page === 1) this.beats = []
                const sharedBeat = this.getParameterByName('beat_id')
                const playlistId = this.returnPlaylistOnly && this.page.playlist_id
                this.getUserBeats(page, 20, sharedBeat, { playlistId })
                    .then((response) => {
                        const data = response.data;
                        let beats = Beat.makeArray(data.items)
                        if (page == 1) this.beats = []
                        this.beats.push(...beats);
                        this.loading = false
                        const completeLoading = data.cursor != undefined && !data.cursor.next;
                        this.updateInfiniteLoading(completeLoading)
                        this.setPagePlaylistItems(beats, page)
                    })
                    .catch(() => {
                        if (page == 1) this.beats = []
                        this.completeInfiniteLoading();
                    })
            },
            updateInfiniteLoading(completeLoading){
                this.$nextTick(() => {
                    if (this.infiniteLoadingState) {
                        if (completeLoading) {
                            this.infiniteLoadingState.complete()
                            return
                        }
                        this.infiniteLoadingState.loaded()
                        }
                    })
            },
            completeInfiniteLoading(){
                if (this.infiniteLoadingState) this.infiniteLoadingState.complete();
                this.loading = false;
            },
            getParameterByName(name) {
                const url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
                if (!results || !results[2]) return null;
                return decodeURIComponent(results[2].replace(/\+/g, " "));
			},
            setPagePlaylistItems(items, page = 1) {
                if (page == 1) {

                    if (this.playlistManager.getPagePlaylist() && this.playlistManager.getPagePlaylist().id == this.pageId) {
                        this.playlistManager.getPagePlaylist().setPlaylistItems(items)
                    } else {
                        this.playlistManager.setPagePlaylist(new Playlist(items, this.page.name, this.pageId))
                    }

                } else {
                    this.playlistManager.getPagePlaylist().addPlaylistItems(items)
                }
            },
            loadMore($state) {
                this.infiniteLoadingState = $state

                if (!this.loading) {
                    this.beatsPage++
                    this.getBeats(this.beatsPage)
                }
            },
            resetInfiniteLoading() {
                if (this.infiniteLoadingState) {
                    this.filteredPlaylist = []
                    this.infiniteLoadingState.reset()
                }
            },
            changeDisplay(display) {
                this.display = display
            },
            closeFilterBar() {
                this.$store.commit("closeFilterBar", {close: true})
            }
        },
        watch: {
            '$store.state.player.activeItem': {
                handler(item) {
                    if (item) {
                        const itemIndex = this.beats
                            .findIndex(beat => beat.id == item.id)
                        const isNearEnd = this.beats.length - itemIndex < 30
                        if (isNearEnd) {
                            if (!this.loading) {
                                this.beatsPage++
                                this.getBeats(this.beatsPage)
                            }
                        }
                    }
                },
                immediate: true
            },
            '$store.state.filters': {
                handler(val) {
                    if (this.allowUpdate) {
                        this.allowUpdate = false
                        this.setUrlQueryFromBeatFilters()
                        this.$nextTick(() => this.allowUpdate = true)

                        this.beatsPage = 1
                        this.resetInfiniteLoading()

                        this.getBeats(this.beatsPage)
                    }
                },
                deep: true
            },
            '$route.query': {
                handler() {
                    if (this.allowUpdate) {
                        this.allowUpdate = false
                        this.setFiltersFromUrlQuery()
                        this.$nextTick(() => this.allowUpdate = true)

                        this.beatsPage = 1
                        this.resetInfiniteLoading()

                        this.getBeats(this.beatsPage)
                    }
                },
                immediate: true
            },
            'page': {
                handler(page) {
                    this.beats = []
                    this.playlist = null

                    this.getBeats(1)
                },
                deep: true
            },
            'page.display_music': {
                handler(val) {
                    if (val == "block" || val == "list") {
                        this.display = val
                    }
                },
                immediate: true
            }
        }

    }
</script>
